import { render, staticRenderFns } from "./trackRecalls.vue?vue&type=template&id=1606b966&"
import script from "./trackRecalls.vue?vue&type=script&lang=js&"
export * from "./trackRecalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports